module.exports = {"seopress_robots_enable":{"type":"checkbox","name":"Enable robots.txt"},"seopress_robots_file":{"type":"textarea","name":"robots.txt"},"seopress_htaccess_file":{"type":"textarea","name":".htaccess file"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Manager/Site/Plugins/seopresspro.json
// module id = SJfQ
// module chunks = 17